import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface WhoAmIResponse extends BackendResponse, Profile {}

export interface WhoAmIParameters extends NextApiParams {}

export const whoAmI = withNextApi<WhoAmIResponse, WhoAmIParameters>(
  "/auth/WhoAmI",
  {
    method: "GET",
  }
);

export interface Profile {
  concernId: number | null;
  hasProfileInConcern: boolean;
  hasProfileInConcerns: number[];
  numProfiles: number;
  name: string;
  provider: string;
  id: string;
  idCandidate?: number;
  claims: ProfileClaim[];
  hasCvpToken: boolean;
  details: ProfileExtraDetails;

  /**
   * Do not use this value directly for translating.
   * Instead use the hook useEvaluatedLocale.
   */
  locale?: string;
  environment?: string;
}

export interface ProfileClaim {
  name: string;
  value: string;
}

export interface ProfileExtraDetails {
  concernName: string;
  candidateId: number | null;
  firmId: number | null;
  concernId: number;
}
